(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pj-hero-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var viewport=root.querySelector('[data-pjhc-viewport]');
    var slides=Array.prototype.slice.call(viewport.querySelectorAll('.pjhc__slide'));
    var dotsWrap=root.querySelector('[data-pjhc-dots]');
    var prev=root.querySelector('[data-pjhc-prev]');
    var next=root.querySelector('[data-pjhc-next]');
    var toggle=root.querySelector('[data-pjhc-toggle]');
    if(!viewport||slides.length===0)return;
    if(slides.length<2){var controls=root.querySelector('.pjhc__controls');if(controls)controls.hidden=true;return;}
    var active=0;
    var timer=null;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay=root.getAttribute('data-autoplay')==='true'&&!reduce;
    var manuallyPaused=false;
    var interval=parseInt(root.getAttribute('data-interval'),10)||5000;
    var dots=slides.map(function(slide,index){
      var button=document.createElement('button');
      button.type='button';
      button.className='pjhc__dot'+(index===0?' is-active':'');
      button.setAttribute('aria-label','Go to banner '+(index+1));
      button.addEventListener('click',function(){go(index,true);});
      dotsWrap.appendChild(button);
      return button;
    });
    function update(index){
      active=Math.max(0,Math.min(slides.length-1,index));
      dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===active);});
    }
    function go(index,user){
      var target=(index+slides.length)%slides.length;
      viewport.scrollTo({left:slides[target].offsetLeft,behavior:reduce?'auto':'smooth'});
      update(target);
      if(user)restart();
    }
    function stop(){if(timer){window.clearInterval(timer);timer=null;}}
    function updateToggle(){
      if(!toggle)return;
      var paused=!autoplay||manuallyPaused;
      toggle.setAttribute('aria-label',paused?toggle.dataset.labelPlay:toggle.dataset.labelPause);
      toggle.querySelector('span').textContent=paused?'▶':'Ⅱ';
    }
    function start(){
      if(!autoplay||manuallyPaused||document.hidden)return;
      stop();
      timer=window.setInterval(function(){go(active+1,false);},interval);
    }
    function restart(){stop();start();}
    prev.addEventListener('click',function(){go(active-1,true);});
    next.addEventListener('click',function(){go(active+1,true);});
    if(toggle){
      toggle.addEventListener('click',function(){
        manuallyPaused=!manuallyPaused;
        if(manuallyPaused)stop();else start();
        updateToggle();
      });
      updateToggle();
    }
    var raf=0;
    viewport.addEventListener('scroll',function(){
      if(raf)return;
      raf=requestAnimationFrame(function(){
        raf=0;
        var index=Math.round(viewport.scrollLeft/Math.max(1,viewport.clientWidth));
        update(index);
      });
    },{passive:true});
    viewport.addEventListener('pointerdown',stop,{passive:true});
    viewport.addEventListener('pointerup',restart,{passive:true});
    viewport.addEventListener('touchend',restart,{passive:true});
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',start);
    document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else start();});
    start();
  }
  function boot(){document.querySelectorAll('[data-pjhc]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();

  } catch(e) { console.error(e); }
})();
})();
